<template>
    <Modal class="confirm-modal"
           :icon="icon"
           :title="title"
           :custom-title-text="customTitleText"
           :size="modalSize">
        <DialogText :text-lang-keys="textLangKeys"
                    :custom-text="customText"
                    :custom-html="customHtml " />

        <template v-slot:footer>
            <div class="modl-footer confirm-modal__btns">
                <DialogCancelBtn :color="cancelColor"
                                 :custom-text="cancelCustomText"
                                 :label="cancelLabel"
                                 @click="resolve(false)" />
                <DialogOkBtn :color="okColor"
                             :custom-text="okCustomText"
                             :label="okLabel"
                             @click="resolve(true)" />
            </div>
        </template>
    </Modal>
</template>

<script>
import DialogCancelBtn from '@/vue/modals/Dialogs/components/DialogCancelBtn';
import DialogOkBtn from '@/vue/modals/Dialogs/components/DialogOkBtn';
import DialogText from '@/vue/modals/Dialogs/components/DialogText';
import Modal from '@/vue/components/Modals/Modal';
import { DialogPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogPropsMixin';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

/**
 * @typedef {Object} ConfirmModalProps
 * @property {string} [title] - Lang string for the title of the modal.
 * @property {string} [okColor] - Colour class for the OK button (default, danger, success, etc.).
 * @property {string} [okLabel] - Lang string for the OK button.
 * @property {string} [cancelColor] - Colour class for the Cancel button (default, danger, success, etc.).
 * @property {string} [cancelLabel] - Lang string for the Cancel button.
 * @property {string} [customText] - Custom text to show instead of the lang string.
 */

export default {
    components: {
        Modal,
        DialogOkBtn,
        DialogCancelBtn,
        DialogText,
    },

    mixins: [
        ModalPropsMixin,
        DialogPropsMixin,
    ],

    props: {
        // These duplicate props from mixins to change the default values.
        title: {
            type: String,
            default: 'DIALOGS.CONFIRM_TITLE',
        },
        customTitleText: {
            type: String,
            default: null,
        },
        cancelLabel: {
            type: String,
            default: 'DIALOGS.NO_LABEL',
        },
        cancelColor: {
            type: String,
            default: 'danger',
        },
        okLabel: {
            type: String,
            default: 'DIALOGS.YES_LABEL',
        },
        okColor: {
            type: String,
            default: 'success',
        },
    },
};
</script>
